import * as coreClient from "@azure/core-client";

export const ProjectListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ProjectListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Project",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Project: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Project",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      maxDevBoxesPerUser: {
        constraints: {
          InclusiveMinimum: 0,
        },
        serializedName: "maxDevBoxesPerUser",
        type: {
          name: "Number",
        },
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CloudError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CloudError",
    modelProperties: {
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "CloudErrorBody",
        },
      },
    },
  },
};

export const CloudErrorBody: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CloudErrorBody",
    modelProperties: {
      code: {
        serializedName: "code",
        required: true,
        type: {
          name: "String",
        },
      },
      message: {
        serializedName: "message",
        required: true,
        type: {
          name: "String",
        },
      },
      target: {
        serializedName: "target",
        type: {
          name: "String",
        },
      },
      details: {
        serializedName: "details",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CloudErrorBody",
            },
          },
        },
      },
    },
  },
};

export const ProjectAbilities: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ProjectAbilities",
    modelProperties: {
      abilitiesAsAdmin: {
        serializedName: "abilitiesAsAdmin",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "DeleteDevBoxes",
                "DeleteEnvironments",
                "ManageEnvironmentActions",
                "ReadDevBoxes",
                "ReadEnvironmentActions",
                "ReadEnvironmentOutputs",
                "ReadEnvironments",
                "StartDevBoxes",
                "StopDevBoxes",
                "WriteDevBoxes",
                "WriteEnvironments",
              ],
            },
          },
        },
      },
      abilitiesAsDeveloper: {
        serializedName: "abilitiesAsDeveloper",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "CustomizeDevBoxes",
                "DeleteDevBoxes",
                "DeleteEnvironments",
                "ManageDevBoxActions",
                "ManageEnvironmentActions",
                "ReadDevBoxActions",
                "ReadDevBoxes",
                "ReadEnvironmentActions",
                "ReadEnvironmentOutputs",
                "ReadEnvironments",
                "ReadRemoteConnections",
                "StartDevBoxes",
                "StopDevBoxes",
                "WriteDevBoxes",
                "WriteEnvironments",
              ],
            },
          },
        },
      },
    },
  },
};

export const PoolListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PoolListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Pool",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Pool: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Pool",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      location: {
        serializedName: "location",
        required: true,
        type: {
          name: "String",
        },
      },
      osType: {
        defaultValue: "Windows",
        isConstant: true,
        serializedName: "osType",
        type: {
          name: "String",
        },
      },
      hardwareProfile: {
        serializedName: "hardwareProfile",
        type: {
          name: "Composite",
          className: "HardwareProfile",
        },
      },
      hibernateSupport: {
        serializedName: "hibernateSupport",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled", "OsUnsupported"],
        },
      },
      storageProfile: {
        serializedName: "storageProfile",
        type: {
          name: "Composite",
          className: "StorageProfile",
        },
      },
      imageReference: {
        serializedName: "imageReference",
        type: {
          name: "Composite",
          className: "ImageReference",
        },
      },
      localAdministrator: {
        serializedName: "localAdministrator",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"],
        },
      },
      stopOnDisconnect: {
        serializedName: "stopOnDisconnect",
        type: {
          name: "Composite",
          className: "StopOnDisconnectConfiguration",
        },
      },
      healthStatus: {
        serializedName: "healthStatus",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Pending",
            "Healthy",
            "Warning",
            "Unhealthy",
          ],
        },
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const HardwareProfile: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "HardwareProfile",
    modelProperties: {
      skuName: {
        serializedName: "skuName",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      vCPUs: {
        serializedName: "vCPUs",
        readOnly: true,
        type: {
          name: "Number",
        },
      },
      memoryGB: {
        serializedName: "memoryGB",
        readOnly: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const StorageProfile: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageProfile",
    modelProperties: {
      osDisk: {
        serializedName: "osDisk",
        type: {
          name: "Composite",
          className: "OSDisk",
        },
      },
    },
  },
};

export const OSDisk: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OSDisk",
    modelProperties: {
      diskSizeGB: {
        serializedName: "diskSizeGB",
        readOnly: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const ImageReference: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ImageReference",
    modelProperties: {
      name: {
        serializedName: "name",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "version",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      operatingSystem: {
        serializedName: "operatingSystem",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      osBuildNumber: {
        serializedName: "osBuildNumber",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      publishedDate: {
        serializedName: "publishedDate",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const StopOnDisconnectConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StopOnDisconnectConfiguration",
    modelProperties: {
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"],
        },
      },
      gracePeriodMinutes: {
        serializedName: "gracePeriodMinutes",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const ScheduleListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ScheduleListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Schedule",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Schedule: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Schedule",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      sourceUri: {
        serializedName: "sourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      sourceType: {
        defaultValue: "Pool",
        isConstant: true,
        serializedName: "sourceType",
        type: {
          name: "String",
        },
      },
      type: {
        defaultValue: "StopDevBox",
        isConstant: true,
        serializedName: "type",
        type: {
          name: "String",
        },
      },
      frequency: {
        defaultValue: "Daily",
        isConstant: true,
        serializedName: "frequency",
        type: {
          name: "String",
        },
      },
      time: {
        serializedName: "time",
        required: true,
        type: {
          name: "String",
        },
      },
      timeZone: {
        serializedName: "timeZone",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CustomizationTaskDefinitionListResult: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskDefinitionListResult",
      modelProperties: {
        value: {
          serializedName: "value",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "CustomizationTaskDefinition",
              },
            },
          },
        },
        nextLink: {
          serializedName: "nextLink",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const CustomizationTaskDefinition: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomizationTaskDefinition",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      catalogName: {
        serializedName: "catalogName",
        required: true,
        type: {
          name: "String",
        },
      },
      uri: {
        serializedName: "uri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      parameters: {
        serializedName: "parameters",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "CustomizationTaskDefinitionParameter",
            },
          },
        },
      },
    },
  },
};

export const CustomizationTaskDefinitionParameter: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskDefinitionParameter",
      modelProperties: {
        description: {
          serializedName: "description",
          type: {
            name: "String",
          },
        },
        type: {
          serializedName: "type",
          required: true,
          type: {
            name: "Enum",
            allowedValues: ["string", "number", "boolean"],
          },
        },
        required: {
          serializedName: "required",
          type: {
            name: "Boolean",
          },
        },
        default: {
          serializedName: "default",
          type: {
            name: "String",
          },
        },
        allowed: {
          constraints: {
            MinItems: 1,
            UniqueItems: true,
          },
          serializedName: "allowed",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "String",
              },
            },
          },
        },
      },
    },
  };

export const CustomizationTaskList: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomizationTaskList",
    modelProperties: {
      tasks: {
        serializedName: "tasks",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomizationTask",
            },
          },
        },
      },
    },
  },
};

export const CustomizationTask: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomizationTask",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      parameters: {
        serializedName: "parameters",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String",
        },
      },
      timeout: {
        serializedName: "timeout",
        type: {
          name: "Number",
        },
      },
      runAs: {
        serializedName: "runAs",
        type: {
          name: "String",
        },
      },
      id: {
        serializedName: "id",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      logUri: {
        serializedName: "logUri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Running",
            "Succeeded",
            "FailedValidation",
            "Skipped",
            "TimedOut",
            "Failed",
            "WaitingForUserInputUac",
            "WaitingForUserSession",
          ],
        },
      },
      startTime: {
        serializedName: "startTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const CustomizationTaskListValidationResult: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskListValidationResult",
      modelProperties: {
        validationResult: {
          serializedName: "validationResult",
          required: true,
          type: {
            name: "Enum",
            allowedValues: ["Succeeded", "Failed"],
          },
        },
        errors: {
          serializedName: "errors",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "CustomizationTaskListValidationError",
              },
            },
          },
        },
      },
    },
  };

export const CustomizationTaskListValidationError: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskListValidationError",
      modelProperties: {
        target: {
          serializedName: "target",
          type: {
            name: "Composite",
            className: "CustomizationTask",
          },
        },
        details: {
          serializedName: "details",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "CustomizationTaskListValidationErrorDetails",
              },
            },
          },
        },
      },
    },
  };

export const CustomizationTaskListValidationErrorDetails: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskListValidationErrorDetails",
      modelProperties: {
        code: {
          serializedName: "code",
          required: true,
          type: {
            name: "String",
          },
        },
        message: {
          serializedName: "message",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const OperationStatus: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OperationStatus",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceId: {
        serializedName: "resourceId",
        type: {
          name: "String",
        },
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime",
        },
      },
      percentComplete: {
        constraints: {
          InclusiveMaximum: 100,
          InclusiveMinimum: 0,
        },
        serializedName: "percentComplete",
        type: {
          name: "Number",
        },
      },
      properties: {
        serializedName: "properties",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "OperationStatusError",
        },
      },
    },
  },
};

export const OperationStatusError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OperationStatusError",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "String",
        },
      },
      message: {
        serializedName: "message",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DevBox",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBox: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBox",
    modelProperties: {
      uri: {
        serializedName: "uri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      projectName: {
        serializedName: "projectName",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      poolName: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "poolName",
        required: true,
        type: {
          name: "String",
        },
      },
      hibernateSupport: {
        serializedName: "hibernateSupport",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled", "OsUnsupported"],
        },
      },
      provisioningState: {
        serializedName: "provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      actionState: {
        serializedName: "actionState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      powerState: {
        serializedName: "powerState",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Running",
            "Deallocated",
            "PoweredOff",
            "Hibernated",
          ],
        },
      },
      uniqueId: {
        serializedName: "uniqueId",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "CloudErrorBody",
        },
      },
      location: {
        serializedName: "location",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      osType: {
        defaultValue: "Windows",
        isConstant: true,
        serializedName: "osType",
        type: {
          name: "String",
        },
      },
      user: {
        serializedName: "user",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      hardwareProfile: {
        serializedName: "hardwareProfile",
        type: {
          name: "Composite",
          className: "HardwareProfile",
        },
      },
      storageProfile: {
        serializedName: "storageProfile",
        type: {
          name: "Composite",
          className: "StorageProfile",
        },
      },
      imageReference: {
        serializedName: "imageReference",
        type: {
          name: "Composite",
          className: "ImageReference",
        },
      },
      createdTime: {
        serializedName: "createdTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      localAdministrator: {
        serializedName: "localAdministrator",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"],
        },
      },
    },
  },
};

export const CustomizationGroupListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomizationGroupListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomizationGroup",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CustomizationGroup: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomizationGroup",
    modelProperties: {
      tasks: {
        serializedName: "tasks",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomizationTask",
            },
          },
        },
      },
      uri: {
        serializedName: "uri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Running",
            "Succeeded",
            "Failed",
            "ValidationFailed",
          ],
        },
      },
      startTime: {
        serializedName: "startTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const RemoteConnection: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "RemoteConnection",
    modelProperties: {
      webUrl: {
        serializedName: "webUrl",
        type: {
          name: "String",
        },
      },
      rdpConnectionUrl: {
        serializedName: "rdpConnectionUrl",
        type: {
          name: "String",
        },
      },
      cloudPcConnectionUrl: {
        serializedName: "cloudPcConnectionUrl",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxActionsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxActionsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DevBoxAction",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxAction",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      actionType: {
        defaultValue: "Stop",
        isConstant: true,
        serializedName: "actionType",
        type: {
          name: "String",
        },
      },
      sourceId: {
        serializedName: "sourceId",
        required: true,
        type: {
          name: "String",
        },
      },
      sourceUri: {
        serializedName: "sourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      sourceType: {
        serializedName: "sourceType",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Pool", "Schedule"],
        },
      },
      suspendedUntil: {
        serializedName: "suspendedUntil",
        type: {
          name: "DateTime",
        },
      },
      next: {
        serializedName: "next",
        type: {
          name: "Composite",
          className: "DevBoxNextAction",
        },
      },
    },
  },
};

export const DevBoxNextAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxNextAction",
    modelProperties: {
      scheduledTime: {
        serializedName: "scheduledTime",
        required: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const DevBoxActionsDelayMultipleResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxActionsDelayMultipleResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DevBoxActionDelayResult",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxActionDelayResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxActionDelayResult",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      result: {
        serializedName: "result",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Succeeded", "Failed"],
        },
      },
      action: {
        serializedName: "action",
        type: {
          name: "Composite",
          className: "DevBoxAction",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "CloudErrorBody",
        },
      },
    },
  },
};

export const DevBoxOperationListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxOperationListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DevBoxOperation",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxOperation: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: {
      serializedName: "kind",
      clientName: "kind",
    },
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationId: {
        serializedName: "operationId",
        required: true,
        type: {
          name: "String",
        },
      },
      kind: {
        serializedName: "kind",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Start", "Stop", "Restart", "Repair"],
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Running",
            "Succeeded",
            "Canceled",
            "Failed",
          ],
        },
      },
      createdByObjectId: {
        serializedName: "createdByObjectId",
        type: {
          name: "String",
        },
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "CloudErrorBody",
        },
      },
    },
  },
};

export const EnvironmentListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Environment",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentPatchProperties: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentPatchProperties",
    modelProperties: {
      expirationDate: {
        serializedName: "expirationDate",
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const EnvironmentOutputs: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentOutputs",
    modelProperties: {
      outputs: {
        serializedName: "outputs",
        type: {
          name: "Dictionary",
          value: {
            type: { name: "Composite", className: "EnvironmentOutput" },
          },
        },
      },
    },
  },
};

export const EnvironmentOutput: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentOutput",
    modelProperties: {
      type: {
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: ["array", "boolean", "number", "object", "string"],
        },
      },
      value: {
        serializedName: "value",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      sensitive: {
        serializedName: "sensitive",
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const EnvironmentOperationListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentOperationListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentOperation",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentOperation: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentOperation",
    uberParent: "EnvironmentOperation",
    polymorphicDiscriminator: {
      serializedName: "kind",
      clientName: "kind",
    },
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationId: {
        serializedName: "operationId",
        required: true,
        type: {
          name: "String",
        },
      },
      kind: {
        serializedName: "kind",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Deploy", "Delete"],
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Running",
            "Succeeded",
            "Canceled",
            "Failed",
          ],
        },
      },
      createdByObjectId: {
        serializedName: "createdByObjectId",
        type: {
          name: "String",
        },
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime",
        },
      },
      environmentParameters: {
        serializedName: "environmentParameters",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "CloudErrorBody",
        },
      },
    },
  },
};

export const EnvironmentActionsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentActionsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentAction",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentAction",
    modelProperties: {
      name: {
        serializedName: "name",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      uri: {
        serializedName: "uri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      actionType: {
        defaultValue: "Delete",
        isConstant: true,
        serializedName: "actionType",
        type: {
          name: "String",
        },
      },
      next: {
        serializedName: "next",
        type: {
          name: "Composite",
          className: "EnvironmentNextAction",
        },
      },
      lastModifiedBy: {
        serializedName: "lastModifiedBy",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      lastModifiedAt: {
        serializedName: "lastModifiedAt",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const EnvironmentNextAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentNextAction",
    modelProperties: {
      scheduledTime: {
        serializedName: "scheduledTime",
        required: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const CatalogListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CatalogListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Catalog",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Catalog: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Catalog",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentDefinitionListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentDefinitionListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentDefinition",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentDefinition: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentDefinition",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      catalogName: {
        serializedName: "catalogName",
        required: true,
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      parameters: {
        serializedName: "parameters",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentDefinitionParameter",
            },
          },
        },
      },
      parametersSchema: {
        serializedName: "parametersSchema",
        type: {
          name: "String",
        },
      },
      templatePath: {
        serializedName: "templatePath",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentDefinitionParameter: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentDefinitionParameter",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      default: {
        serializedName: "default",
        type: {
          name: "String",
        },
      },
      type: {
        serializedName: "type",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "array",
            "boolean",
            "integer",
            "number",
            "object",
            "string",
          ],
        },
      },
      readOnly: {
        serializedName: "readOnly",
        type: {
          name: "Boolean",
        },
      },
      required: {
        serializedName: "required",
        required: true,
        type: {
          name: "Boolean",
        },
      },
      allowed: {
        constraints: {
          MinItems: 1,
          UniqueItems: true,
        },
        serializedName: "allowed",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const EnvironmentTypeListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentTypeListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentType",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentType: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentType",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      deploymentTargetId: {
        serializedName: "deploymentTargetId",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"],
        },
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentTypeAbilities: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentTypeAbilities",
    modelProperties: {
      abilitiesAsAdmin: {
        serializedName: "abilitiesAsAdmin",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "DeleteEnvironments",
                "ManageEnvironmentActions",
                "ReadEnvironmentActions",
                "ReadEnvironmentOutputs",
                "ReadEnvironments",
                "WriteEnvironments",
              ],
            },
          },
        },
      },
      abilitiesAsDeveloper: {
        serializedName: "abilitiesAsDeveloper",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "DeleteEnvironments",
                "ManageEnvironmentActions",
                "ReadEnvironmentActions",
                "ReadEnvironmentOutputs",
                "ReadEnvironments",
                "WriteEnvironments",
              ],
            },
          },
        },
      },
    },
  },
};

export const NotificationSettings: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NotificationSettings",
    modelProperties: {
      name: {
        defaultValue: "default",
        isConstant: true,
        serializedName: "name",
        type: {
          name: "String",
        },
      },
      enabled: {
        serializedName: "enabled",
        required: true,
        type: {
          name: "Boolean",
        },
      },
      culture: {
        serializedName: "culture",
        required: true,
        type: {
          name: "String",
        },
      },
      notificationType: {
        serializedName: "notificationType",
        type: {
          name: "Composite",
          className: "NotificationType",
        },
      },
    },
  },
};

export const NotificationType: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NotificationType",
    modelProperties: {
      devBoxProvisioningNotification: {
        serializedName: "devBoxProvisioningNotification",
        type: {
          name: "Composite",
          className: "DevBoxProvisioningNotification",
        },
      },
    },
  },
};

export const DevBoxProvisioningNotification: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxProvisioningNotification",
    modelProperties: {
      enabled: {
        serializedName: "enabled",
        required: true,
        type: {
          name: "Boolean",
        },
      },
      notificationChannel: {
        serializedName: "notificationChannel",
        type: {
          name: "Composite",
          className: "NotificationChannel",
        },
      },
    },
  },
};

export const NotificationChannel: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NotificationChannel",
    modelProperties: {
      emailNotification: {
        serializedName: "emailNotification",
        type: {
          name: "Composite",
          className: "EmailNotification",
        },
      },
      webhookNotification: {
        serializedName: "webhookNotification",
        type: {
          name: "Composite",
          className: "WebhookNotification",
        },
      },
    },
  },
};

export const EmailNotification: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EmailNotification",
    modelProperties: {
      enabled: {
        serializedName: "enabled",
        required: true,
        type: {
          name: "Boolean",
        },
      },
      recipients: {
        serializedName: "recipients",
        type: {
          name: "String",
        },
      },
      cc: {
        serializedName: "cc",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebhookNotification: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebhookNotification",
    modelProperties: {
      enabled: {
        serializedName: "enabled",
        required: true,
        type: {
          name: "Boolean",
        },
      },
      url: {
        serializedName: "url",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NotificationSettingsAllowedCulturesListResult: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "NotificationSettingsAllowedCulturesListResult",
      modelProperties: {
        value: {
          serializedName: "value",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "String",
              },
            },
          },
        },
      },
    },
  };

export const ArtifactListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ArtifactListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Artifact",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Artifact: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Artifact",
    modelProperties: {
      id: {
        serializedName: "id",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      isDirectory: {
        serializedName: "isDirectory",
        readOnly: true,
        type: {
          name: "Boolean",
        },
      },
      downloadUri: {
        serializedName: "downloadUri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      fileSize: {
        serializedName: "fileSize",
        readOnly: true,
        type: {
          name: "Number",
        },
      },
      createdTime: {
        serializedName: "createdTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      lastModifiedTime: {
        serializedName: "lastModifiedTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const DevBoxRepairOperationResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxRepairOperationResult",
    modelProperties: {
      repairOutcome: {
        serializedName: "repairOutcome",
        type: {
          name: "Enum",
          allowedValues: ["FixApplied", "IssuesDetected", "NoIssuesDetected"],
        },
      },
      code: {
        serializedName: "code",
        type: {
          name: "String",
        },
      },
      message: {
        serializedName: "message",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CustomizationTaskListValidationOperationResult: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskListValidationOperationResult",
      modelProperties: {
        ...OperationStatus.type.modelProperties,
        result: {
          serializedName: "result",
          type: {
            name: "Composite",
            className: "CustomizationTaskListValidationResult",
          },
        },
      },
    },
  };

export const DevBoxStartOperation: coreClient.CompositeMapper = {
  serializedName: "Start",
  type: {
    name: "Composite",
    className: "DevBoxStartOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
    },
  },
};

export const DevBoxStopOperation: coreClient.CompositeMapper = {
  serializedName: "Stop",
  type: {
    name: "Composite",
    className: "DevBoxStopOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
    },
  },
};

export const DevBoxRestartOperation: coreClient.CompositeMapper = {
  serializedName: "Restart",
  type: {
    name: "Composite",
    className: "DevBoxRestartOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
    },
  },
};

export const DevBoxRepairOperation: coreClient.CompositeMapper = {
  serializedName: "Repair",
  type: {
    name: "Composite",
    className: "DevBoxRepairOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
      result: {
        serializedName: "result",
        type: {
          name: "Composite",
          className: "DevBoxRepairOperationResult",
        },
      },
    },
  },
};

export const EnvironmentUpdateProperties: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentUpdateProperties",
    modelProperties: {
      ...EnvironmentPatchProperties.type.modelProperties,
      parameters: {
        serializedName: "parameters",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const EnvironmentDeployOperation: coreClient.CompositeMapper = {
  serializedName: "Deploy",
  type: {
    name: "Composite",
    className: "EnvironmentDeployOperation",
    uberParent: "EnvironmentOperation",
    polymorphicDiscriminator:
      EnvironmentOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...EnvironmentOperation.type.modelProperties,
    },
  },
};

export const EnvironmentDeleteOperation: coreClient.CompositeMapper = {
  serializedName: "Delete",
  type: {
    name: "Composite",
    className: "EnvironmentDeleteOperation",
    uberParent: "EnvironmentOperation",
    polymorphicDiscriminator:
      EnvironmentOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...EnvironmentOperation.type.modelProperties,
    },
  },
};

export const Environment: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Environment",
    modelProperties: {
      ...EnvironmentUpdateProperties.type.modelProperties,
      uri: {
        serializedName: "uri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      environmentType: {
        serializedName: "environmentType",
        required: true,
        type: {
          name: "String",
        },
      },
      user: {
        serializedName: "user",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      provisioningState: {
        serializedName: "provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      resourceGroupId: {
        serializedName: "resourceGroupId",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      catalogName: {
        serializedName: "catalogName",
        required: true,
        type: {
          name: "String",
        },
      },
      environmentDefinitionName: {
        serializedName: "environmentDefinitionName",
        required: true,
        type: {
          name: "String",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "CloudErrorBody",
        },
      },
    },
  },
};

export const DevCenterListAllDevBoxesExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevCenterListAllDevBoxesExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevCenterListAllDevBoxesByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevCenterListAllDevBoxesByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevCenterGetNotificationSettingsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevCenterGetNotificationSettingsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevCenterCreateNotificationSettingsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevCenterCreateNotificationSettingsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevCenterListNotificationSettingsAllowedCulturesExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "DevCenterListNotificationSettingsAllowedCulturesExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevCenterListAllDevBoxesNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevCenterListAllDevBoxesNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevCenterListAllDevBoxesByUserNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevCenterListAllDevBoxesByUserNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListPoolsExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesListPoolsExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesGetPoolExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesGetPoolExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesListSchedulesByProjectExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSchedulesByProjectExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListSchedulesByPoolExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSchedulesByPoolExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetScheduleByPoolExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetScheduleByPoolExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListDevBoxesByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListDevBoxesByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetDevBoxByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetDevBoxByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesCreateDevBoxExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesCreateDevBoxExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesDeleteDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesDeleteDevBoxHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesDeleteDevBoxExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesDeleteDevBoxExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesStartDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesStartDevBoxHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesStartDevBoxExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesStartDevBoxExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesStopDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesStopDevBoxHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesStopDevBoxExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesStopDevBoxExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesRestartDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesRestartDevBoxHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesRestartDevBoxExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesRestartDevBoxExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesRepairDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesRepairDevBoxHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesRepairDevBoxExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesRepairDevBoxExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListCustomizationGroupsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListCustomizationGroupsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetCustomizationGroupExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetCustomizationGroupExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesCreateCustomizationGroupExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesCreateCustomizationGroupExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetCustomizationTaskLogExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetCustomizationTaskLogExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetRemoteConnectionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetRemoteConnectionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListActionsExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesListActionsExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesGetActionExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesGetActionExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesSkipActionExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesSkipActionExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesDelayActionExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesDelayActionExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesDelayActionsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesDelayActionsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListOperationsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListOperationsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetOperationExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetOperationExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListPoolsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListPoolsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListSchedulesByProjectNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSchedulesByProjectNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListSchedulesByPoolNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSchedulesByPoolNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListDevBoxesByUserNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListDevBoxesByUserNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListCustomizationGroupsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListCustomizationGroupsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListActionsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListActionsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesDelayActionsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesDelayActionsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListOperationsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListOperationsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ProjectsValidateCustomizationTasksHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ProjectsValidateCustomizationTasksHeaders",
      modelProperties: {
        operationLocation: {
          serializedName: "operation-location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentsByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentsByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetEnvironmentByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetEnvironmentByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsCreateOrReplaceEnvironmentHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsCreateOrReplaceEnvironmentHeaders",
      modelProperties: {
        operationLocation: {
          serializedName: "operation-location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsCreateOrReplaceEnvironmentExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsCreateOrReplaceEnvironmentExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsPatchEnvironmentExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsPatchEnvironmentExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsDeleteEnvironmentHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsDeleteEnvironmentHeaders",
      modelProperties: {
        operationLocation: {
          serializedName: "operation-location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsDeleteEnvironmentExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsDeleteEnvironmentExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetOutputsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetOutputsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListOperationsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListOperationsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetOperationExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetOperationExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetLogsByOperationExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetLogsByOperationExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListActionsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListActionsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetActionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetActionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsSkipActionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsSkipActionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsDelayActionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsDelayActionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListCatalogsByProjectExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListCatalogsByProjectExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetCatalogExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetCatalogExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentDefinitionsByProjectExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListEnvironmentDefinitionsByProjectExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentDefinitionsByCatalogExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListEnvironmentDefinitionsByCatalogExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetEnvironmentDefinitionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetEnvironmentDefinitionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentTypesExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentTypesExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetEnvironmentTypeExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetEnvironmentTypeExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetEnvironmentTypeAbilitiesExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetEnvironmentTypeAbilitiesExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListArtifactsByEnvironmentExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListArtifactsByEnvironmentExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListArtifactsByEnvironmentAndPathExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListArtifactsByEnvironmentAndPathExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentsByUserNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentsByUserNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListOperationsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListOperationsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListActionsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListActionsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListCatalogsByProjectNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListCatalogsByProjectNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentDefinitionsByProjectNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListEnvironmentDefinitionsByProjectNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentDefinitionsByCatalogNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListEnvironmentDefinitionsByCatalogNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentTypesNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentTypesNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListArtifactsByEnvironmentNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListArtifactsByEnvironmentNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListArtifactsByEnvironmentAndPathNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListArtifactsByEnvironmentAndPathNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export let discriminators = {
  DevBoxOperation: DevBoxOperation,
  EnvironmentOperation: EnvironmentOperation,
  "DevBoxOperation.Start": DevBoxStartOperation,
  "DevBoxOperation.Stop": DevBoxStopOperation,
  "DevBoxOperation.Restart": DevBoxRestartOperation,
  "DevBoxOperation.Repair": DevBoxRepairOperation,
  "EnvironmentOperation.Deploy": EnvironmentDeployOperation,
  "EnvironmentOperation.Delete": EnvironmentDeleteOperation,
};
